export default __webpack_public_path__ + "static/media/2027.e0e376f7.png";